import { Glyph } from "../../types";

const SvgCsvExport: Glyph = (props) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect x="4" y="5" width="16" height="14" rx="2"></rect>
      <path d="M4 9.5h16"></path>
      <path d="M8 13h2.25M8 16h2.25"></path>
      <path d="M13 13h2.25M13 16h2.25"></path>
      <path d="M11.4 13.8l-.3.8h.6l-.45.9"></path>
      <path d="M16.4 13.8l-.3.8h.6l-.45.9"></path>
    </svg>
  );
};

export default SvgCsvExport;
